// "Arm sources used by presets" (sources-v2 S9): every camera and screen the project's presets put on stage, kept live so a preset switch never waits for a device to open.
import { presetStreamSources } from '~/lib/videoSource'
import store from '~/store'
import { selectPresets } from '~/store/playback/selectors'
import sourceManager from '.'

/** A user's arm toggle: that source only; auto-arming (`keep_cameras_armed`) is a Settings choice. */
export const setArmed = (id, armed) => {
	if (armed) sourceManager.arm(id)
	else sourceManager.disarm(id)
}

/** Runs from a menu or key press, so the screen's capture prompt has its gesture. */
export const armPresetSources = () => {
	const state = store.getState()
	for (const id of presetStreamSources(selectPresets(state), state.camera?.device))
		if (!sourceManager.snapshot().sources[id]?.armed) sourceManager.arm(id)
}
